<div>
  <u-icon
    class="close-icon"
    (click)="closePopup()"
    [model]="{
    type: 'font',
    value: 'icon-Windows-close',
  }"
    [styles]="{ fontSize: '12px' }"
  ></u-icon>

  <div class="container">
    <span class="title">How to get the Slack channel ID</span>

    <div class="steps-container">
      <div class="step-container">
        <span class="number">1.</span>
        <span class="step">Open Slack</span>
        <u-icon class="slack-icon" [model]="assistantsIconsConst.slack"></u-icon>
      </div>
      <div class="step-container">
        <span class="number">2.</span>
        <span class="step"
          >Locate the channel and click to open the <br />
          channel’s details.</span
        >
      </div>
      <u-icon
        class="icon-step"
        [model]="{
      type: 'img',
      value: { lightUrl: 'assets/settings/slack/step-2.svg' },
    }"
      ></u-icon>
      <div class="step-container">
        <span class="number">3.</span>
        <span class="step">Scroll down and copy the channel ID.</span>
      </div>
      <u-icon
        class="icon-step"
        [model]="{
      type: 'img',
      value: { lightUrl: 'assets/settings/slack/step-3.svg' },
    }"
      ></u-icon>

      <div class="step-container">
        <span class="number">4.</span>
        <span class="step"
          >Paste the channel ID into the relevant <br />
          field in Unleash.</span
        >
      </div>
    </div>

    <u-button class="got-it-button" (onClick)="closePopup()" type="primary" [label]="'Got it'"> </u-button>
  </div>
</div>
